

import React from 'react'
import { framework_tool, utils_tool,component_tool } from '@/tool'
import { connect } from 'dva';
let { Storage } = utils_tool
import { Row, Col, Layout, Button, Icon, Input, Spin, message } from 'antd';
const { WizContainer, modelUtils } = framework_tool
let { WizCard, WizUpload, WizRow, WizButton, WizTypography, WizCropper, WizCropperModal } = component_tool;
const { Paragraph, Text, Title } = WizTypography;
const getParamRecord = (history) => {
  let record = {}
  let index  = history.indexOf("?")
  var query = history.substring(index+1,history.length)
  var vars = query.split("&");
  if(query){
      for (var i=0;i<vars.length;i++) {
          let varIndex  = vars[i].indexOf("=")
          let params =  {[vars[i].substring(0,varIndex)]:vars[i].substring(varIndex+1,vars[i].length)}
          record = {...params,...record}
  }
  }
  return record
}

class ThirdLogin extends WizContainer  {
    constructor(props) {
      super(props);
      let record = getParamRecord(window?.location?.href)
      log.info(`record`,record)
      this.state = {
        record,
        url:'',
        jumpType:0
      };
    }
    
    componentWillMount() {
      this._checkAutoLogin()
    }
    
    /**
     * 
     */
  _checkAutoLogin = () => {
    const {record} = this.state
    const {loginType,corpId,appId,redirectUri,code,state} = record || {}
    log.info(`record`,{corpId,appId,loginType,redirectUri})
    //有存入的第三方登录信息
    let thirdLoginInfo = Storage.getStorage("thirdLoginInfo")|| null
    //对应的应用id有用户信息
    if(code){
      this.doAction({
        path: 'thirdLogin/getLoginInfo',
        payload: {
          key: 'thirdLogin@getLoginInfo',
          apiParams: {loginType,corpId,appId,code}
        },
      })
    }else if(thirdLoginInfo && thirdLoginInfo[corpId]){

      this.doAction({
        path: 'thirdLogin/jumpUrl',
        payload: {
          key: 'thirdLogin@jumpUrl',
          apiParams: {corpId,appId,redirectUri,...thirdLoginInfo[corpId]}
        },
      })
    } 
    else{
    // 根据请求解析出callBackUrl
    this.doAction({
      path: 'thirdLogin/generateCallBackUrl',
      payload: {
        key: 'thirdLogin@generateCallBackUrl',
        apiParams: {corpId,appId,loginType,redirectUri}
      },
    })
    }
  }

  propsAndStateOnChange = {
    callBackUrl: this._callBackUrl.bind(this),
    jumpUrl:this._jumpUrl.bind(this),
    loginInfo:this._loginInfo.bind(this)
  }
  /**
   * 获取用户信息后
   */
  _loginInfo(nextProps, nextState){
    let { loginInfo } = nextProps
    let { corpId,appId,redirectUri } = nextState?.record||{}
    if (loginInfo['success']) {
      let data = loginInfo['data'];
      if(Storage.getStorage("thirdLoginInfo")){
        Storage.setStorage("thirdLoginInfo",{[corpId]:data,...Storage.getStorage("thirdLoginInfo")})
      }else{
        Storage.setStorage("thirdLoginInfo",{[corpId]:data})
      }
      this.doAction({
        path: 'thirdLogin/jumpUrl',
        payload: {
          key: 'thirdLogin@jumpUrl',
          apiParams: {corpId,appId,redirectUri,...data}
        },
      })
      return false;
    }else{
      return false;
    }
  }
  //获取跳转页面后
  _jumpUrl(nextProps, nextState){
    let { jumpUrl } = nextProps
    if (jumpUrl['success']) {
     window.location.replace(jumpUrl['data'])
      return true;
    }else{
      return false;
    }
  }
  //
  _callBackUrl(nextProps, nextState) {
    let { callBackUrl } = nextProps
    let { redirect_uri,state } = nextState
    if (callBackUrl['success']) {
      window.location.replace(callBackUrl['data'])
      // let appid = 'wx4ab9bb1f9f06ca81'
      // let agentid = '1000008'
      // let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri='+redirect_uri
      // +'&response_type=code&scope=SCOPE'+'&agentid='+ agentid+'&state='+state+'#wechat_redirect'
      // nextState['url'] = url
      return false;
    } else {
      message.error(imageCaptcha['msg'] || '获取页面失败,请稍后刷新重试')
      return false;
    }
  }
  handleDownload = ()  => {
    let { corpId,appId,redirectUri,loginType  } = this.state?.record||JSON.parse(this.state?.record?.state)||{}
     //window.location.href = `${url}`
        // 根据请求解析出callBackUrl
        this.doAction({
          path: 'thirdLogin/generateCallBackUrl',
          payload: {
            key: 'thirdLogin@generateCallBackUrl',
            apiParams: {corpId,appId,loginType,redirectUri}
          },
        })
  }
    _render() {
      const { record } = this.state;
      let {redirect_uri,state} = record||{}
      // let appid = 'wx4ab9bb1f9f06ca81'
      // let agentid = '1000008'
      // let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri='+redirect_uri
      // +'&response_type=code&scope=snsapi_base'+'&agentid='+ agentid+'&state='+state+'#wechat_redirect'
        return <>
        <WizCard title='请授权登录' icon={0}>
        <WizButton type='primary' onClick={() => {this.handleDownload()}}> 授权登录</WizButton>
          </WizCard></>
    }
}

const mapStateToProps = (state, ownProps) => {
   const { thirdLogin } = state;
   const callBackUrl = modelUtils.getModelEntity(thirdLogin, 'thirdLogin@generateCallBackUrl');
   const jumpUrl = modelUtils.getModelEntity(thirdLogin, 'thirdLogin@jumpUrl');
   const loginInfo = modelUtils.getModelEntity(thirdLogin, 'thirdLogin@getLoginInfo');
   
  return {
    callBackUrl,
    loginInfo,
    jumpUrl,
  };
};
export default connect(mapStateToProps)(ThirdLogin);